import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ClasswiseAttendanceLayer from "../components/attendance/ClasswiseAttendanceLayer";

const ClasswiseAttendancePage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Class-wise Attendance" />
        <ClasswiseAttendanceLayer />
      </MasterLayout>
    </>
  );
};

export default ClasswiseAttendancePage;
